import noop from 'lodash/noop';
import { sleep } from '@pes-ui/utils';
export const timeLimitedRequest = (func, ms = 5000) => (...args) => {
  return Promise.race([func(...args), sleep(ms)]).catch(noop);
};
export const getMyProductsFromConnector = async () => {
  let resolve = noop;
  const onSucceeded = (event) => {
    resolve(event.detail);
  };
  try {
    const myProductsPromise = new Promise((res) => {
      resolve = res;
      document.addEventListener('pesGetMyProductsSucceeded', onSucceeded);
      document.dispatchEvent(new CustomEvent('pesGetMyProducts'));
    });
    const timeoutPromise = sleep(10000).then(() => null);
    return await Promise.race([myProductsPromise, timeoutPromise]);
  }
  finally {
    document.removeEventListener('pesGetMyProductsSucceeded', onSucceeded);
  }
};
